import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@src/components/Button';
import { OpeningStateEnum } from '@src/graphql/generated';
import Status from './Status';
import './styles.scss';

export default function OpeningActionsButtons({ opening: { state }, actions, onAction }) {
  const hasOnlyIcon = ['pause'];

  return (
    <div className="funnel-overview-header-actions">
      <Status state={state} />

      {actions.map(item => (
        <Button
          appearance={item.appearance}
          icon={item.icon}
          isCircle={hasOnlyIcon.includes(item.key)}
          isDisabled={item.disabled}
          key={item.key}
          onClick={() => onAction(item)}
        >
          {!hasOnlyIcon.includes(item.key) && item.label}
        </Button>
      ))}
    </div>
  );
}

OpeningActionsButtons.propTypes = {
  actions: PropTypes.array.isRequired,
  onAction: PropTypes.func.isRequired,
  opening: PropTypes.shape({
    state: PropTypes.oneOf(Object.values(OpeningStateEnum)).isRequired,
  }).isRequired,
};
